import { MutableRefObject } from "react"
import GoToNext from "../actions/goToNext"
import GoToPrev from "../actions/goToPrev"
import { ControlsMonthlyViewWrapper } from "./styles"
import FullCalendar from "@fullcalendar/react"
interface IProps {
	calendarTitle: string
	calendarRef: MutableRefObject<FullCalendar | null>
}
export default function ControlsMonthlyView({
	calendarTitle,
	calendarRef,
}: IProps) {
	return (
		<ControlsMonthlyViewWrapper>
			<GoToPrev calendarRef={calendarRef} />
			<p>{calendarTitle}</p>
			<GoToNext calendarRef={calendarRef} />
		</ControlsMonthlyViewWrapper>
	)
}
